<template>
  <vx-card
    title="Social Media"
    class="mt-base"
  >
    <vs-input
      class="w-full"
      label="Facebook (www.facebook.com/example)"
      type="url"
      v-model="data.facebook"
    />

    <vs-input
      class="w-full mt-5"
      label="Instagram (www.instagram.com/example)"
      type="url"
      v-model="data.instagram"
    />

    <vs-input
      class="w-full mt-5"
      label="Twitter (www.twitter.com/example)"
      type="url"
      v-model="data.twitter"
    />

    <vs-input
      class="w-full mt-5"
      label="Whatsapp (62 xxxx xxxx xxxx)"
      v-model="data.whatsapp"
    />
  </vx-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
